import React from "react";
import PropTypes from "prop-types";
import HomeContainer from "../components/Home/container";

const IndexPage = ({ data }) => (
  <HomeContainer chapterPath={data.allSoetChapterNode.edges[0].node.path} />
);

export default IndexPage;

IndexPage.propTypes = {
  data: PropTypes.shape({})
};

// eslint-disable-next-line no-undef
export const homeQuery = graphql`
  query homeQuery {
    allSoetChapterNode(limit: 1, sort: { fields: [sortOrder], order: ASC }) {
      edges {
        node {
          id
          sortOrder
          path
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js